<p class="wpdh-note wpdh-note--{{type}}">
  <ng-content></ng-content>
</p>
